export const SPEED = {
  PACMAN_BASE: 1.0,
  GHOST_BLINKY: 0.95,    // Red: a little slower than Pac-Man
  GHOST_SPEEDY: 1.0,     // Purple: same speed as Pac-Man
  GHOST_CLYDE: 0.90,     // Yellow: a little slower
  GHOST_INKY: 0.85,      // Blue: a little slower still
  GHOST_FRIGHTENED_FACTOR: 0.5, // Frightened = 50% of individual normal speed
  GHOST_RETURNING: 0.65,
  LOOP_SPEED_INCREMENT: 0.10,
} as const;

/**
 * Probability that each ghost takes the optimal (BFS-computed) route
 * at an intersection during chase mode. Remaining chance = random direction.
 */
export const GHOST_ROUTING_ACCURACY: Record<string, number> = {
  blinky: 0.99,  // Red: almost always takes optimal route
  speedy: 0.90,  // Purple: 90% optimal
  clyde: 0.85,   // Yellow: 85% optimal
  inky: 0.50,    // Blue: coin-flip between optimal and random
} as const;

/** Chase/scatter mode cycle durations in milliseconds */
export const GHOST_MODE_CYCLES: ReadonlyArray<{
  readonly mode: 'scatter' | 'chase';
  readonly duration: number;
}> = [
  { mode: 'scatter', duration: 7000 },
  { mode: 'chase', duration: 20000 },
  { mode: 'scatter', duration: 7000 },
  { mode: 'chase', duration: 20000 },
  { mode: 'scatter', duration: 5000 },
  { mode: 'chase', duration: 20000 },
  { mode: 'scatter', duration: 5000 },
  // After this, chase forever (handled by code)
] as const;

export const TIMING = {
  POWER_PILL_BASE_DURATION_MS: 8000,
  POWER_PILL_MIN_DURATION_MS: 2000,
  POWER_PILL_FLASH_WARNING_MS: 2500,
  FRUIT_DISPLAY_DURATION_MS: 10000,
} as const;
